<template>
  <div class="viewer" v-show="show" @click.stop="close">
    <div class="viewer__container" @click.stop>
      <div class="viewer__control left" @click="prev"></div>
      <div class="viewer__control right" @click="next"></div>
      <img :src="current_image" class="viewer__image" />
    </div>
  </div>
</template>


<script>
export default {
  name: "gallery-viewer",
  data() {
    return {
      show: false,
      gallery: [],
      cursor: 0,
    };
  },
  computed: {
    current_image() {
      if (this.gallery && this.gallery.length) {
        return this.gallery[this.cursor];
      }
    },
  },
  methods: {
    open(gallery, cursor = 0) {
      this.gallery = gallery;
      this.cursor = cursor;
      this.show = true;
      document.body.classList.add("scroll-blocked");
    },
    close() {
      this.gallery = [];
      this.cursor = 0;
      this.show = false;
      document.body.classList.remove("scroll-blocked");
    },
    next() {
      if (this.gallery.length > this.cursor + 1) {
        this.cursor += 1;
      } else {
        this.cursor = 0;
      }
    },
    prev() {
      if (this.cursor === 0) {
        this.cursor = this.gallery.length - 1;
      } else {
        this.cursor -= 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.viewer {
  position: fixed;
  background: #00000070;
  top: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;

  &__image {
    max-height: 90vh;
  }

  &__container {
    position: relative;
    max-width: 90vw;
  }
  &__control {
    width: 40px;
    height: 70px;
    background: url(../images/icons/arrow-left.svg) no-repeat center/contain;
    position: absolute;
    top: calc(50% - 35px);
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    &.left {
      left: 10px;
    }
    &.right {
      transform: rotateY(180deg);
      right: 10px;
    }
  }
}
</style>